import { useMemo } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { dateRangeOptionsKeys } from 'pages/Tasks/AbsenceRequest/constants'
import { absencePeriods } from 'shared/constants'
import { getSelectOptions } from '../get-select-options'
import type { AbsencePeriodSelectionProps } from '../types'

export const useAbsencePeriodSelection = ({ formFields, formErrors, setValue }: AbsencePeriodSelectionProps) => {
  const { t } = useFavurTranslation()
  const options = getSelectOptions({ options: absencePeriods, t })
  const {
    dateRange: { value: dateRange },
    absencePeriod: { value: absencePeriod },
  } = formFields
  const { absencePeriod: absencePeriodError } = formErrors
  const displayAbsencePeriodDuration = useMemo(() => dateRange === dateRangeOptionsKeys.singleDay, [dateRange])
  const setSelectedValue = (value: number) => {
    const selectedOption = options.find((option) => option.value === value)

    if (!selectedOption) return

    setValue('absencePeriod', selectedOption.key)
  }
  const selectedValue = useMemo(
    () => options.find((option) => option.key === absencePeriod)?.value,
    [absencePeriod, options],
  )

  return {
    absencePeriodError,
    displayAbsencePeriodDuration,
    options,
    selectedValue,
    setSelectedValue,
    t,
  }
}
